
<div>
    <app-bar :title="t('events_title')">
        <template #actions>
            <div class="px-10" v-if="permitted('admin_event_management')">
                <v-btn
                    :to="{ name: 'events.create' }"
                    class="sm"
                    color="orange"
                >{{ t('general_action_create_new') }}</v-btn>
            </div>
        </template>
    </app-bar>

    <v-layout>
        <event-collection></event-collection>
    </v-layout>
</div>
